<template>
    <div class="hover:border hover:border-gray-300 hover:shadow-lg rounded-lg px-2 py-3 cursor-pointer group">
        <div class="flex gap-x-2.5 border-l-2 pl-2">
            <div class="w-5">
                <component
                    :is="icon"
                    :class="[
                        useFill
                            ? 'fill-gray-400 group-hover:fill-gray-900 '
                            : useStroke
                            ? 'stroke-gray-400 group-hover:stroke-gray-900'
                            : 'text-gray-400 group-hover:text-gray-900',
                        'h-5 w-5 ',
                    ]"
                ></component>
            </div>

            <div class="flex flex-col gap-y-1 text-sm leading-5">
                <span class="font-medium text-gray-900 border-tea">{{ title }}</span>
                <span class="font-normal text-gray-400 pe-2">{{ description }}</span>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { Component } from "vue"

interface Props {
    title: string
    description: string
    icon: Component
    useFill?: boolean
    useStroke?: boolean
}
defineProps<Props>()
</script>
